import { gql } from '@apollo/client';

export const INSURANCE_POLICIES_LIST = gql`
  query InsurancePoliciesList($sort: [InsurancePolicySort!]) { 
    insurancePoliciesList(sort: $sort) {
      items {
        id
        provider
        policyNumber
        coverageType
        coverageAmount
        premiumAmount
        deductibleAmount
        effectiveDate
        renewalDate
        status
        agentName
        agentPhone
        agentEmail
        underwriterCompany
        coveredInsurancePolicies {
          firstName
          lastName
          id
        }
        insurancePolicy {
          id
          unitNumber
          vIN
          make
          model
        }
        businessUnits {
            id
            name
        }
        driverApprovalRequest {
          items {
            id
            requestDate
            status
            employee {
              id
              firstName
              lastName
            }
            requestedBy {
              id
              firstName
              lastName
            }
          }
        }
        certificateRequest {
          items {
            id
            requestDate
            status
            client {
              id
              name
            }
            requestedBy {
              id
              firstName
              lastName
            }
          }
        }
        updatedAt
        createdAt
      }
    }
  }
`;

export const INSURANCE_POLICIES_LIST_FILTERED = gql`
  query InsurancePoliciesListFiltered($filter: InsurancePolicyFilter, $sort: [InsurancePolicySort!]) {
    insurancePoliciesList(filter: $filter, sort: $sort) {
      items {
        id
        provider
        policyNumber
        coverageType
        coverageAmount
        premiumAmount
        deductibleAmount
        effectiveDate
        renewalDate
        status
        agentName
        agentPhone
        agentEmail
        underwriterCompany
        coveredInsurancePolicies {
          firstName
          lastName
          id
        }
        insurancePolicy {
          id
          unitNumber
          vIN
          make
          model
        }
        businessUnits {
            id
            name
        }
        driverApprovalRequest {
          items {
            id
            requestDate
            status
            employee {
              id
              firstName
              lastName
            }
            requestedBy {
              id
              firstName
              lastName
            }
          }
        }
        certificateRequest {
          items {
            id
            requestDate
            status
            client {
              id
              name
            }
            requestedBy {
              id
              firstName
              lastName
            }
          }
        }
        updatedAt
        createdAt
      }
    }
  }
`;

export const INSURANCE_POLICY_CREATE = gql`
  mutation InsurancePolicyCreate($data: InsurancePolicyCreateInput!) {
    insurancePolicyCreate(data: $data) {
      id
    }
  }
`;

export const INSURANCE_POLICY_UPDATE = gql`
  mutation InsurancePolicyUpdate($filter: InsurancePolicyKeyFilter!, $data: InsurancePolicyUpdateInput!) {
    insurancePolicyUpdate(filter: $filter, data: $data) {
      id
    }
  }
`;

export const INSURANCE_POLICY_DELETE = gql`
  mutation InsurancePolicyDestroy($filter: InsurancePolicyKeyFilter!) {
    insurancePolicyDestroy(filter: $filter) {
      success
    }
  }
`;

export const INSURANCE_POLICY_GET = gql`
  query InsurancePolicyGet($id: ID!) {
    insurancePolicy(id: $id) {
      id
      provider
      policyNumber
      coverageType
      coverageAmount
      premiumAmount
      deductibleAmount
      effectiveDate
      renewalDate
      status
      agentName
      agentPhone
      agentEmail
      underwriterCompany
      businessUnits {
            id
            name
        }
      insurancePolicy { id make model unitNumber vIN }
      coveredInsurancePolicies { id firstName lastName }
      driverApprovalRequest {
        items {
          id
          requestDate
          status
          employee {
            id
            firstName
            lastName
          }
          requestedBy {
            id
            firstName
            lastName
          }
        }
      }
      certificateRequest {
        items {
          id
          requestDate
          status
          client {
            id
            name
          }
          requestedBy {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const INSURANCE_POLICY_GET_LIST_FILTER = gql`
  query InsurancePolicyGet($id: ID!) {
    insurancePoliciesList(filter: { id: { equals: $id } }) {
      items {
        id
        provider
        policyNumber
        coverageType
        coverageAmount
        premiumAmount
        deductibleAmount
        effectiveDate
        renewalDate
        status
        agentName
        agentPhone
        agentEmail
        underwriterCompany
        coveredInsurancePolicies {
          firstName
          lastName
          id
        }
        insurancePolicy {
          id
          unitNumber
          vIN
          make
          model
        }
        businessUnits {
            id
            name
        }
        driverApprovalRequest {
          items {
            id
            requestDate
            status
            employee {
              id
              firstName
              lastName
            }
            requestedBy {
              id
              firstName
              lastName
            }
          }
        }
        certificateRequest {
          items {
            id
            requestDate
            status
            client {
              id
              name
            }
            requestedBy {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;

// New queries for DriverApprovalRequest
export const DRIVER_APPROVAL_REQUESTS_LIST = gql`
  query DriverApprovalRequestsList {
    driverApprovalRequestsList {
      items {
        id
        requestDate
        status
        emailSentDate
        responseDate
        responseNotes
        approvalDocument {
          items {
            id
            filename
            downloadUrl
            previewUrl
          }
        }
        insurancePolicy {
          id
          provider
          policyNumber
          businessUnits {
            id
            name
          }
        }
        employee {
          id
          firstName
          lastName
          emailAddress
          businessUnits {
            id
            name
          }
          driverLicensePhoto {
            items {
              id
              filename
              downloadUrl
              previewUrl
            }
          }
        }
        requestedBy {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export const DRIVER_APPROVAL_REQUEST_CREATE = gql`
  mutation DriverApprovalRequestCreate($data: DriverApprovalRequestCreateInput!) {
    driverApprovalRequestCreate(data: $data) {
      id
      requestDate
      status
      emailSentDate
      employee {
        id
        firstName
        lastName
        position
        emailAddress
        businessUnits {
          id
          name
        }
      }
      insurancePolicy {
        id
        policyNumber
        provider
        agentName
        agentEmail
        coverageType
        businessUnits {
          id
          name
        }
      }
    }
  }
`;

export const DRIVER_APPROVAL_REQUEST_UPDATE = gql`
  mutation DriverApprovalRequestUpdate($filter: DriverApprovalRequestKeyFilter!, $data: DriverApprovalRequestUpdateInput!) {
    driverApprovalRequestUpdate(filter: $filter, data: $data) {
      id
      requestDate
      status
      emailSentDate
      employee {
        id
        firstName
        lastName
        position
        emailAddress
        businessUnits {
          id
          name
        }
      }
      insurancePolicy {
        id
        policyNumber
        provider
        agentName
        agentEmail
        coverageType
        businessUnits {
          id
          name
        }
      }
    }
  }
`;

export const DRIVER_APPROVAL_REQUEST_DELETE = gql`
  mutation DriverApprovalRequestDestroy($filter: DriverApprovalRequestKeyFilter!) {
    driverApprovalRequestDestroy(filter: $filter) {
      success
    }
  }
`;

// New queries for CertificateRequest
export const CERTIFICATE_REQUESTS_LIST = gql`
  query CertificateRequestsList {
    certificateRequestsList {
      items {
        id
        requestDate
        status
        emailSentDate
        certificateReceivedDate
        certificateDocument {
          items {
            id
            filename
            downloadUrl
            previewUrl
          }
        }
        certificateNumber
        effectiveDates
        insurancePolicy {
          id
          provider
          policyNumber
          businessUnits {
            id
            name
          }
        }
        client {
          id
          name
          address1
          contactInfo
        }
        requestedBy {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export const CERTIFICATE_REQUEST_CREATE = gql`
  mutation CertificateRequestCreate($data: CertificateRequestCreateInput!) {
    certificateRequestCreate(data: $data) {
      id
      requestDate
      status
      certificateNumber
      effectiveDates
      client {
        id
        name
        email
        address1
        address2
        city
        state
        zip
        phone
      }
      insurancePolicy {
        id
        policyNumber
        provider
        agentName
        agentEmail
        coverageType
        businessUnits {
          id
          name
        }
      }
    }
  }
`;

export const CERTIFICATE_REQUEST_UPDATE = gql`
  mutation CertificateRequestUpdate($filter: CertificateRequestKeyFilter!, $data: CertificateRequestUpdateInput!) {
    certificateRequestUpdate(filter: $filter, data: $data) {
      id
    }
  }
`;

export const CERTIFICATE_REQUEST_DELETE = gql`
  mutation CertificateRequestDestroy($filter: CertificateRequestKeyFilter!) {
    certificateRequestDestroy(filter: $filter) {
      success
    }
  }
`;